'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _Text = require('../Text');

var _Toolbar = require('../Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _IconButton = require('../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Paper = require('../Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _Clear = require('../SvgIcon/Clear');

var _Clear2 = _interopRequireDefault(_Clear);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('DialogTitle', function (theme) {
  var _ref;

  return _ref = {
    root: {
      margin: 0,
      padding: theme.typography.rhythmByUnit(3) + ' ' + theme.typography.rhythmByUnit(2),
      height: 'auto',
      flex: '1',
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.getContrastText(theme.palette.background.paper),
      maxWidth: '100%',
      boxSizing: 'border-box'
    },
    primary: {
      backgroundColor: theme.palette.primary[500],
      color: theme.palette.getContrastText(theme.palette.primary[500])
    },
    secondary: {
      backgroundColor: theme.palette.primary[100],
      color: theme.palette.getContrastText(theme.palette.primary[100])
    },
    accent: {
      backgroundColor: theme.palette.accent.A200,
      color: theme.palette.getContrastText(theme.palette.accent.A200)
    },
    error: {
      backgroundColor: theme.palette.error.A200,
      color: theme.palette.getContrastText(theme.palette.error.A200)
    },
    close: {
      display: 'none'
    },
    paper: {
      boxShadow: 'none'
    },
    paperFullscreen: {
      display: 'flex',
      left: 0,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: theme.zIndex.dialog
    }
  }, _defineProperty(_ref, theme.breakpoints.down('sm'), {
    toolbarFullscreen: {
      height: theme.typography.rhythmByUnit(8),
      padding: '0 0 0 ' + theme.typography.rhythmByUnit(1)
    }
  }), _defineProperty(_ref, theme.breakpoints.up('sm'), {
    closeFullscreen: {
      display: 'none'
    },
    fullScreen: {
      backgroundColor: 'initial',
      color: theme.palette.primary[500]
    },
    paperFullscreen: {
      boxShadow: 'none',
      position: 'static'
    }
  }), _ref;
});

var DialogTitle = (_temp = _class = function (_Component) {
  _inherits(DialogTitle, _Component);

  function DialogTitle() {
    _classCallCheck(this, DialogTitle);

    return _possibleConstructorReturn(this, (DialogTitle.__proto__ || Object.getPrototypeOf(DialogTitle)).apply(this, arguments));
  }

  _createClass(DialogTitle, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames, _classNames2, _classNames3;

        var _props = this.props,
            accent = _props.accent,
            children = _props.children,
            classNameProp = _props.className,
            closeClassNameProp = _props.closeClassName,
            Close = _props.closeComponent,
            CloseIcon = _props.closeIconComponent,
            error = _props.error,
            fullScreen = _props.fullScreen,
            onCloseClick = _props.onCloseClick,
            paperClassNameProp = _props.paperClassName,
            primary = _props.primary,
            secondary = _props.secondary,
            Toolbar = _props.toolBarComponent,
            other = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'closeClassName', 'closeComponent', 'closeIconComponent', 'error', 'fullScreen', 'onCloseClick', 'paperClassName', 'primary', 'secondary', 'toolBarComponent']);

        var classes = this.context.styleManager.render(styleSheet);

        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.fullScreen, fullScreen), _defineProperty(_classNames, classes.primary, fullScreen && primary && !(secondary || accent || error)), _defineProperty(_classNames, classes.secondary, fullScreen && secondary && !(accent || error)), _defineProperty(_classNames, classes.accent, fullScreen && accent && !error), _defineProperty(_classNames, classes.error, fullScreen && error), _defineProperty(_classNames, classes.toolbarFullscreen, fullScreen), _classNames), classNameProp);

        var closeClassName = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, classes.closeFullscreen, fullScreen), _defineProperty(_classNames2, classes.close, !fullScreen), _classNames2), closeClassNameProp);

        var paperClassName = (0, _classnames2['default'])((_classNames3 = {}, _defineProperty(_classNames3, classes.paperFullscreen, fullScreen), _defineProperty(_classNames3, classes.paper, !fullScreen), _classNames3), paperClassNameProp);

        return _react2['default'].createElement(
          _Paper2['default'],
          { rounded: false, elevation: 1, className: paperClassName },
          _react2['default'].createElement(
            Toolbar,
            _extends({ 'data-mui-test': 'DialogTitle', className: className }, other),
            _react2['default'].createElement(
              Close,
              { className: closeClassName, onClick: onCloseClick },
              _react2['default'].createElement(CloseIcon, null)
            ),
            typeof children === 'string' ? _react2['default'].createElement(
              _Text.Title,
              { colorInherit: true },
              children
            ) : children
          )
        );
      }

      return render;
    }()
  }]);

  return DialogTitle;
}(_react.Component), _class.propTypes = {
  /**
   * If `true`, the text will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The CSS class name of the close element.
   */
  closeClassName: _PropTypes2['default'].string,
  /**
   * Component to be used as the close element
   */
  closeComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Component to be used as the close element
   */
  closeIconComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, The dialog will be full-screen.
   */
  fullScreen: _PropTypes2['default'].bool,
  /**
   * Callback fires when the close icon is clicked on.
   */
  onCloseClick: _PropTypes2['default'].func,
  /**
   * The CSS class name of the paper element.
   */
  paperClassName: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * Component to be used as the confirmation action node
   */
  toolBarComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func])
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.defaultProps = {
  closeComponent: _IconButton2['default'],
  closeIconComponent: _Clear2['default'],
  toolBarComponent: _Toolbar2['default']
}, _temp);
exports['default'] = DialogTitle;


DialogTitle.displayName = 'DialogTitle';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Dialog/DialogTitle.js
// module id = 632
// module chunks = 32